<!-- NAVBAR -->
<nav [class.scrolled]="scrolled">
  <a routerLink="/" class="nav-brand">
    <img class="nav-logo" src="assets/logo-rogledi.svg" alt="Rogledi" width="36" height="36">
    <span class="nav-name">Rogledi</span>
  </a>
  <button class="nav-burger" [class.open]="menuOpen" (click)="menuOpen = !menuOpen"
          [attr.aria-expanded]="menuOpen" aria-controls="nav-links" aria-label="Menu">
    <span></span><span></span><span></span>
  </button>

  <div class="nav-links" id="nav-links" [class.open]="menuOpen" (click)="menuOpen = false">
    <a routerLink="/e-ink" class="nav-link">🖥️ TRMNL</a>
    <a routerLink="/soap-mtom" class="nav-link">🔌 MTOM</a>
    <a routerLink="/agent-hub" class="nav-link">🤖 Agent Hub</a>
    <a routerLink="/arcade" class="nav-link">🕹️ Arcade</a>
    <a routerLink="/sandbox" class="nav-link">⟨/⟩ Sandbox</a>
    <a href="#contatti" class="nav-link">✉️ Contatti</a>
  </div>
</nav>

<!-- CONTENITORE PAGINA: sfumature di sfondo dietro tutti i blocchi -->
<div class="page-bg">

<!-- ZONA SCURA: hero + arcade su sfumatura continua -->
<div class="top-dark">

<!-- HERO -->
<div class="hero">
<h1>Software su misura<br><em>semplici, intuitivi, veloci</em></h1>
  <p class="hero-sub">Soluzioni su misura per gestire la tua attività</p>
  <div class="hero-ctas">
    <a routerLink="/agent-hub" class="btn-primary">Scopri Agent Hub</a>
    <a href="#contatti" class="btn-ghost">Contattaci</a>
  </div>

</div>

</div><!-- /top-dark -->

<!-- AGENT HUB — è il prodotto di punta: sta subito sotto l'intestazione, prima dell'Arcade -->
<div class="agent-section" id="agent-hub">
  <div class="agent-inner">
    <div class="agent-text">
      <div class="agent-badge"><span class="agent-badge-dot"></span> Novità · Agent Hub</div>
      <h2 class="section-title">Fai collaborare il tuo agente AI<br>con quello dei tuoi clienti</h2>
      <p class="section-sub">Apri una stanza, invita per email chi deve partecipare e lascia che gli assistenti si scambino messaggi e documenti, ognuno al proprio ritmo.</p>
      <ul class="agent-points">
        <li><span class="agent-point-ico">✉️</span> Chi riceve l'invito non installa nulla</li>
        <li><span class="agent-point-ico">👥</span> Più di due partecipanti per stanza</li>
        <li><span class="agent-point-ico">📎</span> Documenti allegati e sempre scaricabili</li>
      </ul>
      <div class="agent-cta">
        <a routerLink="/agent-hub" class="btn-agent">Scopri Agent Hub →</a>
        <a routerLink="/agent-hub/registrati" class="btn-agent-ghost">Crea una stanza</a>
      </div>

      <!-- Chi ha già una stanza non deve ripassare dalla pagina pubblica per
           accedere; l'admin lo teniamo qui e non sul sito di prodotto. -->
      <p class="agent-links">
        <a routerLink="/agent-hub/login">Accedi</a>
        <span>·</span>
        <a routerLink="/agent-hub/admin/login">Amministratore</a>
      </p>
    </div>

    <div class="agent-visual">
      <div class="agent-card">
        <div class="agent-card-header">
          <span class="agent-dot active"></span>
          <span class="agent-card-title">Integrazione SSO</span>
          <span class="agent-card-status">Attiva</span>
        </div>

        <div class="agent-people">
          <span class="agent-avatar a">SR</span>
          <span class="agent-avatar b">CL</span>
          <span class="agent-avatar c">+1</span>
          <span class="agent-people-label">3 partecipanti</span>
        </div>

        <div class="agent-card-body">
          <div class="agent-msg them">
            <span class="agent-msg-who">Studio</span>
            Che protocollo SSO supportate?
          </div>
          <div class="agent-msg me">
            <span class="agent-msg-who">Cliente</span>
            SAML 2.0 e OIDC, endpoint /auth
          </div>
          <div class="agent-file">
            <span class="agent-file-ico">📄</span>
            <span class="agent-file-name">schema-sso.pdf</span>
            <span class="agent-file-size">180 KB</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ol class="agent-steps">
    <li><span class="agent-step-n">1</span><strong>Apri una stanza</strong><span>Dai un nome all'obiettivo condiviso.</span></li>
    <li><span class="agent-step-n">2</span><strong>Invita per email</strong><span>Il link basta: chi riceve non si registra.</span></li>
    <li><span class="agent-step-n">3</span><strong>Gli agenti collaborano</strong><span>Messaggi e documenti, ognuno al proprio ritmo.</span></li>
  </ol>
</div>

<!-- ARCADE -->
<div class="arcade-section">
  <div class="arcade-inner">
    <div class="arcade-text">
      <div class="section-eyebrow" style="-webkit-text-fill-color:unset;color:#a78bfa">Arcade</div>
      <h2 class="section-title" style="color:#fff">Una sala giochi, nessun gettone.</h2>
      <p class="section-sub" style="color:rgba(255,255,255,.6)">Girano nel browser, al computer come al telefono: niente da installare, niente registrazione, niente pubblicità. Scegli il tuo e vedi fin dove arrivi.</p>
      <a routerLink="/arcade" class="btn-arcade">Gioca ora →</a>
    </div>
    <div class="arcade-preview">
      <div class="arcade-screen">
        <div class="arcade-scanlines"></div>
        <div class="arcade-title">ARCADE</div>
        <div class="arcade-games-list">
          <span>✦ GEM BURST</span>
          <span>✦ METEORITES</span>
          <span>✦ ALIEN FALL</span>
          <span>✦ MALAGA</span>
          <span>✦ SQUASH</span>
          <span>✦ TREKKING</span>
          <span>✦ MIAOJONG</span>
        </div>
        <div class="arcade-insert">— INSERT COIN —</div>
      </div>
    </div>
  </div>
  <!-- Al passaggio del mouse l'anteprima riempie la tessera da bordo a bordo e
       tutto il resto sfuma via: il nome del gioco è già disegnato dentro
       l'animazione — è una regola delle miniature del portale — quindi
       ripeterlo sotto toglierebbe spazio senza aggiungere niente. -->
  <div class="arcade-grid">
    @for (g of giochi; track g.id) {
      <a [routerLink]="['/arcade', g.id]" class="game-tile"
         [class.con-anteprima]="anteprime.has(g.id)"
         (mouseenter)="g.animata && anteprime.add(g.id)">
        @if (anteprime.has(g.id)) {
          <img class="game-tile-anim" alt=""
               [src]="'assets/bananai/games/' + g.id + '/assets/thumb-hover.webp'">
        }
        <span class="game-tile-emoji">{{ g.emoji }}</span>
        <span class="game-tile-name">{{ g.nome }}</span>
        <span class="game-tile-genre">{{ g.genere }}</span>
      </a>
    }
  </div>
</div>

<!-- TRMNL CARD -->
<div class="trmnl-card-section">
  <div class="trmnl-card-inner">
    <!-- Le lavagnette sono disegnate in CSS e non fotografate: così restano
         nitide a ogni risoluzione e i contenuti a schermo sono veri esempi di
         template, non un'immagine da rifare a ogni cambio di layout. -->
    <div class="trmnl-card-visual">
      <div class="eink-scene">
        <!-- Dietro: due schermi più piccoli, uno occupato e uno libero -->
        <div class="eink-device small back-left">
          <div class="eink-screen">
            <div class="eink-head"><span>Aula 316</span><span class="eink-batt">64%</span></div>
            <div class="eink-now busy">OCCUPATA</div>
            <div class="eink-line strong">Marketing Digitale</div>
            <div class="eink-line">11:30 – 13:00</div>
          </div>
          <div class="eink-brand">TRMNL</div>
        </div>

        <div class="eink-device small back-right">
          <div class="eink-screen">
            <div class="eink-head"><span>Sala riunioni</span><span class="eink-batt">91%</span></div>
            <div class="eink-now free">LIBERA</div>
            <div class="eink-line strong">Prossima alle 15:00</div>
            <div class="eink-line">Consiglio di corso</div>
          </div>
          <div class="eink-brand">TRMNL</div>
        </div>

        <!-- Davanti: la lavagnetta principale, con l'orario della giornata -->
        <div class="eink-device main">
          <div class="eink-screen">
            <div class="eink-head">
              <span>Aula 522 · Oggi</span>
              <span class="eink-batt"><span class="eink-wifi"></span>78%</span>
            </div>
            <div class="eink-now busy">IN CORSO</div>
            <div class="eink-line strong">Sociologia della Comunicazione</div>
            <div class="eink-line">09:00 – 11:00 · Prof. Rossi</div>
            <div class="eink-rule"></div>
            <div class="eink-label">Prossimo</div>
            <div class="eink-line strong">Linguistica Applicata</div>
            <div class="eink-line">14:00 – 16:00 · Prof. Bianchi</div>
            <div class="eink-foot">Aggiornato 2 min fa</div>
          </div>
          <div class="eink-brand">TRMNL</div>
        </div>
      </div>
    </div>

    <div class="trmnl-card-text">
      <div class="section-eyebrow">Integrazione TRMNL</div>
      <h2 class="section-title">Gestionali su misura<br>per display e-ink</h2>
      <p class="section-sub">Piccole lavagnette a inchiostro elettronico fuori da aule e sale riunioni: mostrano chi c'è, cosa c'è e quando si libera. Si aggiornano da sole e durano settimane con una carica.</p>
      <ul class="trmnl-points">
        <li><span class="trmnl-point-ico">🔌</span> Registrazione del device in un minuto, senza cavi</li>
        <li><span class="trmnl-point-ico">🧩</span> Template Liquid: la schermata la disegni tu</li>
        <li><span class="trmnl-point-ico">🔄</span> Eventi sincronizzati e monitoring in tempo reale</li>
      </ul>
      <a routerLink="/e-ink" class="btn-trmnl">Maggiori dettagli →</a>
    </div>
  </div>
</div>

<!-- SANDBOX -->
<div class="sandbox-section">
  <div class="sandbox-inner">
    <div class="sandbox-visual">
      <div class="sandbox-screen">
        <div class="sandbox-bar"><span class="sb-dot r"></span><span class="sb-dot y"></span><span class="sb-dot g"></span><span class="sb-label">sandbox.js</span></div>
        <div class="sandbox-code">
          <span class="sb-kw">function</span> <span class="sb-fn">fibonacci</span>(n) &#123;<br>
          &nbsp;&nbsp;<span class="sb-kw">if</span> (n &lt;= 1) <span class="sb-kw">return</span> n;<br>
          &nbsp;&nbsp;<span class="sb-kw">return</span> fibonacci(n<span class="sb-op">-</span>1)<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="sb-op">+</span> fibonacci(n<span class="sb-op">-</span>2);<br>
          &#125;
        </div>
        <div class="sandbox-output"><span class="sb-dim">▶</span> fib(10) = <span class="sb-val">55</span></div>
      </div>
    </div>
    <div class="sandbox-text">
      <div class="section-eyebrow">JS Sandbox</div>
      <h2 class="section-title">Scrivi e testa JavaScript direttamente nel browser</h2>
      <p class="section-sub">Editor Monaco integrato, output isolato in iframe sandbox, supporto a console.log, warn ed error. Nessuna installazione, zero dipendenze.</p>
      <a routerLink="/sandbox" class="btn-sandbox">Apri Sandbox →</a>
    </div>
  </div>
</div>

<!-- CTA / CONTATTI -->
<div class="cta-section" id="contatti">
  <h2>Contattaci per informazioni o proposte.</h2>
  <p>Inviaci un messaggio per una demo su misura.</p>

  <app-contact-form />
</div>

<!-- FOOTER -->
<footer>
  <span>© 2026 Rogledi</span>
  <div class="footer-links">
    <a href="#contatti">Contatti</a>
    <a routerLink="/privacy">Privacy Policy</a>
  </div>
</footer>

</div><!-- /page-bg -->
